import { useCallback, useEffect } from 'react';
import { useState } from 'react';

import api from '~/services/api';

import CreateOrEditPackage from './CreateOrEditPackage';
import PackagesList from './PackagesList';

export type Package = {
  id: number;
  professional_id: number;
  gym_id: number;
  name: string;
  lealtad: string;
  status: string;
  value: number;
  number_of_training_programs: number;
  created_at: string;
  updated_at: string;
};

type RequestProps = {
  data: Package[];
};

export function Package() {
  const [isCreateOrEdit, setIsCreateOrEdit] = useState<'create' | 'edit'>(
    'create',
  );
  const [packageToEditData, setPackageToEditData] = useState<Package>(
    {} as Package,
  );
  const [packages, setPackages] = useState<Package[]>([] as Package[]);
  const [showContent, setShowContent] = useState<
    'packages' | 'create-or-edit-package'
  >('packages');

  // load packages
  const loadPackages = useCallback(async () => {
    const { data } = await api.get<RequestProps>('packages');

    setPackages(data.data);
  }, []);

  useEffect(() => {
    loadPackages();
  }, [loadPackages]);

  const handleChangeContentToShow = () => {
    return showContent === 'packages' ? (
      <PackagesList
        packages={packages}
        loadPackages={loadPackages}
        showContent={setShowContent}
        setIsCreateOrEdit={setIsCreateOrEdit}
        setPackageToEditData={setPackageToEditData}
      />
    ) : (
      <CreateOrEditPackage
        showContent={setShowContent}
        isCreateOrEdit={isCreateOrEdit}
        editPackageData={packageToEditData}
        loadPackages={loadPackages}
      />
    );
  };

  return <>{handleChangeContentToShow()}</>;
}
